export const CHECKBOX_INTEGRATION_GET_REQUEST = 'CHECKBOX_INTEGRATION_GET_REQUEST'
export const CHECKBOX_INTEGRATION_GET_SUCCESS = 'CHECKBOX_INTEGRATION_GET_SUCCESS'
export const CHECKBOX_INTEGRATION_GET_FAILURE = 'CHECKBOX_INTEGRATION_GET_FAILURE'
export const CHECKBOX_INTEGRATION_UPDATE_REQUEST = 'CHECKBOX_INTEGRATION_UPDATE_REQUEST'
export const CHECKBOX_INTEGRATION_UPDATE_SUCCESS = 'CHECKBOX_INTEGRATION_UPDATE_SUCCESS'
export const CHECKBOX_INTEGRATION_UPDATE_FAILURE = 'CHECKBOX_INTEGRATION_UPDATE_FAILURE'

export const checkboxIntegrationGetRequest = () => ({
  type: CHECKBOX_INTEGRATION_GET_REQUEST
})

export const checkboxIntegrationGetSuccess = (payload) => ({
  type: CHECKBOX_INTEGRATION_GET_SUCCESS,
  payload
})

export const checkboxIntegrationGetFailure = (error) => ({
  type: CHECKBOX_INTEGRATION_GET_FAILURE,
  error
})

export const checkboxIntegrationUpdateRequest = (payload) => ({
  type: CHECKBOX_INTEGRATION_UPDATE_REQUEST,
  payload
})

export const checkboxIntegrationUpdateSuccess = (payload) => ({
  type: CHECKBOX_INTEGRATION_UPDATE_SUCCESS,
  payload
})

export const checkboxIntegrationUpdateFailure = (error) => ({
  type: CHECKBOX_INTEGRATION_UPDATE_FAILURE,
  error
})
